import { call, put, takeLatest } from 'redux-saga/effects';
import { sendStatistics } from '../actions/actions';

import { mainApi } from '../api/mainApi';

function* handleSendStatistics( body ) {
	try {
		const response = yield call(
			mainApi(
				'https://wpwizardapi.siteground.com/statistics',
				'POST',
				body.payload,
				{
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				}
			)
		);
	} catch (e) {
		console.error(`${e}`, e);
	}
}

function* installation(): any {
	yield takeLatest(sendStatistics, handleSendStatistics);
}

export default installation;
